import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  UniAccordionModule,
  UniAlertModule,
  UniButtonsModule,
  UniFormFieldModule,
  UniHeadingModule,
  UniIconsModule,
  UniInputModule,
  UniStepperModule,
  UniSummaryModule,
  UniTableModule,
} from "@universal-ui";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgxFileDropModule } from "ngx-file-drop";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { UiSwitchModule } from "ngx-ui-switch";

import { FormSharedModule } from "@shared/FormShared/form-shared.module";
import { DateModule } from "@shared/Modules/date.module";
import { DropdownModule } from "@shared/Modules/dropdown.module";
import { FormComponentsModule } from "@shared/Modules/formComponents.module";
import { SharedModule } from "@shared/Modules/shared.module";
import { TableModule } from "@shared/Modules/table.module";
import { ValidatorsModule } from "@shared/Modules/validators.module";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { AsociarUsuarioComponent } from "./app-movil/asociar-usuario/asociar-usuario.component";
import { ConsultarUsuarioComponent } from "./app-movil/consultar-usuario/consultar-usuario.component";
import { CanalesRoutingModule } from "./canales-routing";
import { DashboardCanalesComponent } from "./Dashboard/dashboard.component";
import { EditUserComponent } from "./EditUser/edit-user.component";
import { FiltroTablaComponent } from "./Filtro/filtro.component";
import { FiltroAppTablaComponent } from "./FiltroAppUser/filtro-app.component";
import { NotificacionesComponent } from "./notificaciones/notificaciones.component";
import { PermisosComponent } from "./permisos/permisos.component";
import { AccessFormComponent } from "./Shared/Components/AccessForm/access-form.component";
import { ConfirmationComponent } from "./Shared/Components/Confirmation/confirmation.component";
import { PersonalDataFormComponent } from "./Shared/Components/PersonalDataForm/personal-data-form.component";
import { IdentificationTypePipe } from "./Shared/Pipes/identification-type.pipe";
import { CanalesRepository } from "./Shared/Repositories/canales.repository";
import { CanalesAccessFormService } from "./Shared/Services/canales-access-form.service";
import { CanalesAsociarUsuarioService } from "./Shared/Services/canales-asociar-usuario.service";
import { CanalesDashboardService } from "./Shared/Services/canales-dashboard.service";
import { CanalesService } from "./Shared/Services/canales.service";
import { UserCreationService } from "./Shared/user-creation.service";
import { UserCreationComponent } from "./UserCreation/user-creation.component";
import { DashboardFiduciaryAdminComponent } from "./UserFiduciary/Dashboard/dashboard-user-fiduciary.component";
import { EditUserFiduciaryComponent } from "./UserFiduciary/EditUser/edit-user-fiduciary.component";
import { AccessFormFiduciaryComponent } from "./UserFiduciary/Shared/Components/AccessForm/access-form-fiduciary.component";
import { ConfirmationFiduciaryComponent } from "./UserFiduciary/Shared/Components/Confirmation/confirmation-fiduciary.component";
import { PermisosNuevoAdministradorFiduciariaComponent } from "./UserFiduciary/Shared/Components/Permisos/permisos.component";
import { CanalesUserFiduciaryRepository } from "./UserFiduciary/Shared/Repository/canales-user-fiduciary.repository";
import { NuevoFiduciariaService } from "./UserFiduciary/Shared/Services/nuevo-fiduciaria.service";
import { UserCreationFiduciaryComponent } from "./UserFiduciary/user-creation-fiduciary/user-creation-fiduciary.component";

@NgModule({
  declarations: [
    DashboardCanalesComponent,
    FiltroTablaComponent,
    FiltroAppTablaComponent,
    PermisosComponent,
    UserCreationComponent,
    PersonalDataFormComponent,
    AccessFormComponent,
    ConfirmationComponent,
    EditUserComponent,
    IdentificationTypePipe,
    NotificacionesComponent,
    PermisosNuevoAdministradorFiduciariaComponent,
    UserCreationFiduciaryComponent,
    AccessFormFiduciaryComponent,
    DashboardFiduciaryAdminComponent,
    EditUserFiduciaryComponent,
    ConfirmationFiduciaryComponent,
    AsociarUsuarioComponent,
    ConsultarUsuarioComponent,
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    UniButtonsModule,
    UniIconsModule,
    UniHeadingModule,
    CanalesRoutingModule,
    DateModule,
    UniAlertModule,
    UniSummaryModule,
    DropdownModule,
    ValidatorsModule,
    TableModule,
    UniTableModule,
    NgSelectModule,
    UniStepperModule,
    UniAccordionModule,
    FormComponentsModule,
    UiSwitchModule,
    NgxFileDropModule,
    UniFormFieldModule,
    UniInputModule,
    FormSharedModule,
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [FiltroTablaComponent, FiltroAppTablaComponent],
  providers: [
    FileHandlerService,
    CanalesRepository,
    CanalesService,
    UserCreationService,
    provideNgxMask({ validation: true }),
    UsuariosRepository,
    NuevoFiduciariaService,
    CanalesUserFiduciaryRepository,
    CanalesDashboardService,
    CanalesAccessFormService,
    CanalesAsociarUsuarioService,
  ],
})
export class CanalesModule {}
